var map = {
	"./Positive.png": "42b7",
	"./announcement.png": "463f",
	"./archive.png": "6b9c",
	"./health-insurance.png": "17b7",
	"./magistrate.png": "111e",
	"./srdekatlon.png": "13c5",
	"./stars.png": "aa72",
	"./team.png": "a63c",
	"./video.png": "d8cf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "89b8";